import register from '@iez/core/start/init/register'
import { ref } from '@vue/composition-api'
import Search from './component/'
import router, { routeCurrent } from '@iez/core/router/'

register({
  pages: {
    Search
  }
})

export const model = ref(``)

export const search = async () => {
  if (!model.value || model.value === routeCurrent.params.query) {
    return
  }
  router.replace({
    name: `Search`,
    params: {
      query: model.value
    }
  })
  return
}
